import { ArticleGrid } from '@src/components/sco/ArticleGrid'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { ArticleOrderByInput, ArticleType } from '@src/graphql-types.ts'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect.tsx'
import { Block } from '@src/pages/landing/first-10k.tsx'
import { EducationPage } from '@src/templates/EducationPage.tsx'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default EducationPage(function Page() {
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setItem(null)
    activeContent.setSiteSection('lexicon.landing')
    activeContent.setBreadcrumbs([{ title: 'Lexicon', href: '/lexicon' }])
  }, [])

  return (
    <Block boxProps={{ background: 'transparent' }} headingProps={{ children: 'Startups.com Lexicon' }}>
      <ArticleGrid
        baseUrl={'lexicon'}
        filters={{ type: ArticleType.Lexicon, tagSlugs: ['featured'] }}
        order={ArticleOrderByInput.TitleAsc}
      />
    </Block>
  )
})
